<style scoped lang="less">
.phone {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  .phone-title {
    cursor: pointer;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-content: center;
    height: 30px;
    opacity: 1;
    font-size: 22px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    color: #000000;
    line-height: 30px;
    :first-child {
      color: #00bfbf;
    }
    span {
      cursor: pointer;
    }
  }
}
.phoneBackground {
  // width: 300px;
  // height: 600px;
  width: 300px;
  height: 650px;
  background-image: url("../../assets/phone/phone.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 300px auto;
  // background-color: #faf;
  padding: 85px 21px 100px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  div {
    overflow-y: auto;
    width: 100%;
    height: 100%;
  }
  div::-webkit-scrollbar {
    display: none;
  }
  .content {
    width: 100%;
    p {
      font-weight: 600;
      font-size: 20px;
      text-align: center;
    }
  }
  .content-phone {
    width: 100%;
    p {
      font-weight: 600;
      font-size: 14px;
      text-align: left;
    }
    .title {
      text-align: center;
    }
  }
}
</style>
<template>
  <div>
    <el-dialog :visible.sync="centerDialogVisible" :show-close="false">
      <div class="phone">
        <div class="phone-title">
          <p @click="handelGoBack">返回</p>
          <p>活动预览</p>
          <p>
            <span v-if="showParentsSubmit" @click="handelSure">立即发布</span>
          </p>
        </div>
        <div class="phoneBackground">
          <div class="content" v-if="!form.activitySourceUrl">
            <p>{{ form.activityTitle }}</p>
            <div v-html="form.activityText"></div>
          </div>
          <div class="content-phone" v-else>
            <p class="title">{{ form.activityTitle }}</p>
            <p>数据来源:{{ form.activitySource }}</p>
            <p>
              活动地址: 
              <a @click="handelUrl" >{{
                form.activitySourceUrl
              }}</a>
            </p>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  props: ["form", "showParentsSubmit"],

  components: {},
  data() {
    return {
      centerDialogVisible: false,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    if (this.form.activityText != null) {
      const regex = new RegExp("<img", "gi");
      this.form.activityText = this.form.activityText.replace(
        regex,
        `<img style="max-width: 100%; height: auto"`
      );
    }
  },
  methods: {
    handelUrl() {
      let lg = this.form.activitySourceUrl.indexOf("http");
      if (lg < 0) {
        return window.open("http://" + this.form.activitySourceUrl);
      }
      window.open(this.form.activitySourceUrl);
    },
    handelSure() {
      this.$parent.submitForm("ruleForm", "02", "立即发布");
    },
    handelGoBack() {
      // this.$parent.handelBack();
      this.centerDialogVisible = false;
    },
    goShow() {
      this.centerDialogVisible = true;
    },
  },
};
</script>
